import { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { PageHeader, SearchEmpty, DataTable } from "components";
import { IDataTableColumn } from "components/DataTable/interface";
import { colors } from "global/globalStyle";
import dayjs from "dayjs";

import { usePermissions } from "hooks/permission";
import { useToast } from "hooks/toast";

import { ReportsService } from "services/reportsService";

import { FORMS_RELATORIOS } from "utils/entities/permission";

import { Container, ContainerBody, ContainerList } from "./styles";
import { ContainerLeftMenu } from "../../Administration/styles";
import { ReportMenu } from "../ReportMenu";

export function LoggedUsers() {
  const { t } = useTranslation();
  const [listOfLoggedUsers, setListOfLoggedUsers] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  const columns: IDataTableColumn[] = [
    {
      id: "name",
      label: t("common.name"),
      width: "50%",
      align: "left",
    },
    {
      id: "lastRefresh",
      label: t("reports.columns.lastLogin"),
      width: "50%",
      align: "center",
      format: (value) => {
        if (!value) return "N/A";
        const date = dayjs(value);
        return (
          <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <div>{date.format("DD/MM/YYYY")}</div>
            <div style={{ fontSize: "11px", color: colors.neutral_gray_40 }}>
              {date.format("HH:mm:ss")}
            </div>
          </div>
        );
      },
    },
  ];

  const { addToast } = useToast();

  const { read } = usePermissions(FORMS_RELATORIOS.LOGGED_USERS);

  useEffect(() => {
    (async () => {
      setLoading(true);
      await onLoadList();
      setLoading(false);
    })();
  }, []);

  async function onLoadList() {
    const response = await ReportsService.getLoggedUsers();

    if (response) {
      if (response.status) {
        setListOfLoggedUsers(response.data.data);
      } else {
        addToast({
          type: "warning",
          title: response.message,
        });
      }
    }
    return [];
  }

  return (
    <Container>
      <ContainerLeftMenu>
        <ReportMenu />
      </ContainerLeftMenu>
      <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
        <PageHeader
          quantity={listOfLoggedUsers.length > 0 ? listOfLoggedUsers.length : 0}
          id="header"
          label={t("reports.loggedUsers.title")}
          background="secondary"
          addClick={undefined}
          disabled={false}
        />
        <ContainerBody>
          {read ? (
            <>
              <ContainerList>
                <DataTable
                  columns={columns}
                  rows={listOfLoggedUsers}
                  loading={loading}
                  emptyMessage={t("reports.loggedUsers.none")}
                  maxHeight="60vh"
                  stickyHeader
                  striped
                />
              </ContainerList>
            </>
          ) : (
            <SearchEmpty
              textMessage={t("common.noPermissionForProfile")}
              typeIcon={"avatar"}
              marginTop="30px"
            />
          )}
        </ContainerBody>
      </div>
    </Container>
  );
}
